export const walletConnectFailureTitle = (reason: unknown): string =>
  typeof reason !== "object" ? "Wallet connection was cancelled." : "Couldn't connect your wallet. Please try again.";

export const walletDisconnectFailureTitle = (): string => "Couldn't disconnect your wallet. Please try again.";
